import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KycComponent } from './kyc/kyc.component';
import { ConsentComponent } from './consent/consent.component';
import { CreditParametersComponent } from './credit-parameters/credit-parameters.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    KycComponent,
    ConsentComponent,
    CreditParametersComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule
  ]
})
export class MonedoModule { }
